import { type FC, type ComponentProps } from "react";
import { CassetteSlider } from "@root/userFrontend/components/CassettesSlider";
import { type WorkCassette } from "@root/userFrontend/components/WorkCassette";
import { DUMMY_IMAGE_PATH } from "@root/shared/utils/constants";
import { useEntryLink } from "@userFrontend/hooks/useEntryLink";
import * as styles from "./styles.css";

type CassetteProps = {
  events: {
    cassetteEvent: {
      cassetteGaAction: string;
      cassetteGaLabel: string;
    };
    keepButtonEvent: {
      keepGaAction: string;
      keepGaLabel: string;
    };
    entryLinkEvent: {
      entryGaAction: string;
      entryGaLabel: string;
    };
  };
  workCode: string;
  detailUrl: string;
  entryUrl: string;
  businessTypeAndOccupation: string;
  shopOrBrandName: string;
  title: string;
  imgSrc: string;
  shopLocation: string;
  salaries: {
    employmentTypeName: string;
    salaryTypeName: string;
    minPrice: string;
    minUnit: string;
    maxPrice: string;
    maxUnit: string;
  }[];
  keepButtonContent: {
    keepButtonUrl: string;
    hasKeeped: boolean;
  };
};

type TransformedCassetteProps = ComponentProps<typeof WorkCassette>;

type Props = {
  cassettes: CassetteProps[];
};

const KEEP_GA_ACTION = "tap_step2_completed_rich_job_keep";
const ENTRY_GA_ACTION = "tap_step2_completed_rich_job_entry";

export const RegistrationCompleteCassettes: FC<Props> = ({ cassettes }) => {
  const { handleClickEntryLink } = useEntryLink();
  const transformedCassettes: TransformedCassetteProps[] = cassettes.map((cassette) => ({
    type: "simplified",
    gaAction: cassette.events.cassetteEvent.cassetteGaAction,
    gaLabel: cassette.events.cassetteEvent.cassetteGaLabel,
    detailUrl: cassette.detailUrl,
    headerContents: {
      imgSrc: cassette.imgSrc,
      dummyImgPath: DUMMY_IMAGE_PATH,
      shopOrBrandName: cassette.shopOrBrandName,
      businessTypeAndOccupation: cassette.businessTypeAndOccupation,
      title: cassette.title,
    },
    salaries: cassette.salaries,
    shopLocation: cassette.shopLocation,
    buttonProps: {
      entryButtonUrl: cassette.entryUrl,
      entryGaAction: ENTRY_GA_ACTION,
      entryGaLabel: cassette.events.entryLinkEvent.entryGaLabel,
      keepButtonUrl: cassette.keepButtonContent.keepButtonUrl,
      keepGaAction: KEEP_GA_ACTION,
      keepGaLabel: cassette.events.keepButtonEvent.keepGaLabel,
      hasKeeped: cassette.keepButtonContent.hasKeeped,
      workCode: cassette.workCode,
      entryUrl: cassette.entryUrl,
      onClickEntryLink: handleClickEntryLink,
    },
  }));

  return (
    <div className={styles.outer}>
      <CassetteSlider cassetteType="CategoryTopCassette" cassettes={transformedCassettes} />
    </div>
  );
};
